import { render, staticRenderFns } from "./list.vue?vue&type=template&id=20374c91&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20374c91",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20374c91')) {
      api.createRecord('20374c91', component.options)
    } else {
      api.reload('20374c91', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=20374c91&scoped=true&", function () {
      api.rerender('20374c91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/constructionEquipmentMgr/stockMgr/list.vue"
export default component.exports